var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-col pb-5" },
    [
      _c("Skeleton", { attrs: { width: 420, height: 24 } }),
      _c("Skeleton", { attrs: { width: 200, height: 24 } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }